"use strict";
/*
 * © 2026 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLinearScale = exports.getAbsoluteToleranceDirection = exports.getToleranceDirection = void 0;
/** Shared by the measurement tolerance graphic. Direction is inferred from the sign of whichever
 * limit is defined, since that graphic's limits are offsets relative to nominal (e.g. +/-0.5). */
const getToleranceDirection = (lowerLimit, upperLimit) => [lowerLimit, upperLimit].every((x) => x === undefined)
    ? "none"
    : [lowerLimit, upperLimit].includes(undefined)
        ? [lowerLimit, upperLimit].every((x) => !x || x > 0)
            ? "single positive"
            : "single negative"
        : "double";
exports.getToleranceDirection = getToleranceDirection;
/** Used by the box plot graphic, whose limits are absolute values (e.g. LSL/USL) rather than offsets,
 * so direction must be inferred from which limit is defined, not its sign. */
const getAbsoluteToleranceDirection = (lowerLimit, upperLimit) => lowerLimit === undefined && upperLimit === undefined
    ? "none"
    : lowerLimit === undefined
        ? "single positive"
        : upperLimit === undefined
            ? "single negative"
            : "double";
exports.getAbsoluteToleranceDirection = getAbsoluteToleranceDirection;
/** A simple linear (affine) scale, equivalent to d3-scale's scaleLinear for this single use case */
const createLinearScale = (domain, range) => {
    const [d0, d1] = domain;
    const [r0, r1] = range;
    const factor = d1 === d0 ? 0 : (r1 - r0) / (d1 - d0);
    return (value) => r0 + (value - d0) * factor;
};
exports.createLinearScale = createLinearScale;
//# sourceMappingURL=toleranceScale.js.map